import React from 'react';
import { HelpCircle } from 'lucide-react';

export function HelpText({ children }) {
  return (
    <div className="page-intro-help">
      <HelpCircle size={16} />
      <div>{children}</div>
    </div>
  );
}

export function QuickActions({ children }) {
  return <div className="page-intro-actions">{children}</div>;
}

export default function PageIntro({ title, eyebrow, description, children, aside, icon: Icon, iconColor }) {
  return (
    <div className="page-intro-shell card">
      <div className="card-body page-intro-card">
        <div className="page-intro-main">
          {eyebrow ? <div className="page-intro-eyebrow">{eyebrow}</div> : null}
          <h1>
            {Icon ? (
              <span className="page-header-icon" style={{ '--page-header-icon-color': iconColor || 'var(--red)' }}>
                <Icon size={19} />
              </span>
            ) : null}
            <span>{title}</span>
          </h1>
          {description ? <p>{description}</p> : null}
          {children}
        </div>
        {aside ? <div className="page-intro-aside">{aside}</div> : null}
      </div>
    </div>
  );
}
